import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames'; 
import CostCenterImportForm from '../Forms/CostCenterImportForm';

const ImportCostCenterModal = ({
	isOpen,
	isEdit,
	handleToggleModalImport,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModalImport}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModalImport}>
				Importar Centros de Costo
			</ModalHeader>

			<CostCenterImportForm
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModalImport={handleToggleModalImport}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default ImportCostCenterModal;
